import React, {useState, useEffect} from 'react';
import { Link, useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import Editor from 'react-simple-wysiwyg';
import { API_URL } from '../global/components/Constants';
import { getCategories } from '../utils/api-services/global';
import { 
    jobTypesUtil, 
    workModeUtil, 
    qualificationUtil, 
    experienceLevelUtil,
    experienceLengthUtil } from '../utils/jobUtils';
import OrgSelectControl from '../organization/components/OrgSelectControl';
import Tags from '../global/components/Tags';

function JobPostEdit() {

    const [job, setJob] = useState(null);
    const [settings, setSettings] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedItem, setSelectedItem] = useState("");
    const [value, setValue] = useState("");
    const [tagList, setTagList] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [frmError, setFrmError] = useState("");
    const [loading, setLoading] = useState(false);
    const [posting, setPosting] = useState(false);

    const { code } = useParams();

    useEffect(()=>{
        loadJobPost();
        loadCategories();
    }, []);

    function loadJobPost(){
        setLoading(true);
        axios({
            method: 'get',
            url: API_URL + `job/job_post_by_slug?slug=${code}`,
        }).then((respose)=>{
            const obj = respose.data;
            if(obj.Success){
                setLoading(false);
                setJob(obj.Data);
                parseSettingsData(obj.Data);
            }
        });
    }

    const loadCategories = async () => {
        const data = await getCategories();
        setCategories(data);
    }

    const showModal = ()=>{
        clearForm();
        setModal(true);
    }

    const closeModal = ()=>{
        setModal(false);
    }

    const updateOrg = (val)=>{
        setValue(val)
    }

    const handleDescription = (e)=>{
        setValue(e.target.value)
    }

    function editPreset(obj){
        showModal();
        setModalTitle(obj.Title);
        setSelectedItem(obj.Code);

        if(obj.Code == "Tags"){
            setTagList(obj.Value);
        }
        else{
            setValue(obj.Value);
        }
    }

    function saveForm(){
        if(selectedItem == "Tags"){
            if(tagList.length == 0){
                setFrmError("Please add tags");
                return false;
            }
            postForm(selectedItem, JSON.stringify(tagList));
        }
        else{
            if(value == ""){
                setFrmError("Please enter value");
                return false;
            }
            postForm(selectedItem, value);
        }
    }

    function postForm(column, value){

        setPosting(true);

        const formData = new FormData();
        formData.append('id', job?.Id);
        formData.append('column', column);
        formData.append('value', value);

        axios({
            method: "post",
            url: API_URL + "job/update_job_post_column",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
            processData: false,
            contentType: false,
            mimeType: "multipart/form-data",
            withCredentials: true
        })
        .then(function (response) {
            setPosting(false)
            const obj = response.data;
            if(obj.Success){
                loadJobPost();
                closeModal();
            }
        })
        .catch(function (response) {
            setPosting(false)
        });
    }

    function clearForm(){
        setValue("");
        setTagList([]);
        setFrmError("");
    }

    const styles = {
        page:{
            background: '#fff',
            minHeight: 700,
            paddingTop: 50,
            paddingBottom: 100
        },
        heading:{
            display: 'flex'
        },
        title:{
            color: '#999',
            marginBottom: 0,
            fontSize: 18
        },
        link:{
            color: '#363636',
            marginRight: 30,
            fontSize: 14,
            fontWeight: 500,
            textDecoration: 'none',
            marginLeft: 'auto'
        },
        item:{
            sm:{
                wrap:{
                    paddingTop: 15,
                    paddingBottom: 15,
                    borderBottom: '1px solid #ccc'
                },
                title:{
                    color: '#191919',
                    fontSize: 14,
                    fontWeight: 600
                },
                value: {
                    color: '#333',
                    fontSize: 13
                },
                btn:{
                    color: '#0767ce',
                    fontSize: 14,
                    textDecoration: 'none',
                },
            },
            md:{
                wrap:{
                    paddingTop: 15,
                    paddingBottom: 15,
                    borderBottom: '1px solid #ccc'
                },
                title:{
                    color: '#191919',
                    fontSize: 16,
                    fontWeight: 600
                },
                value: {
                    color: '#333',
                    fontSize: 16
                },
                btn:{
                    color: '#0767ce',
                    fontSize: 14,
                    textDecoration: 'none',
                },
            },
            lg:{
                wrap:{
                    paddingTop: 15,
                    paddingBottom: 15,
                    borderBottom: '1px solid #ccc'
                },
                title:{
                    color: '#191919',
                    fontSize: 16,
                    fontWeight: 600
                },
                value: {
                    color: '#333',
                    fontSize: 24
                },
                btn:{
                    color: '#0767ce',
                    fontSize: 14,
                    textDecoration: 'none',
                },
            },
        },
        selectBtnWrap: {
            marginBottom: 10,
        },
        selectBtn: {
            textDecoration: 'none',
            fontSize: 16,
        },
        info: {
            fontSize: 13,
        },
        frmError:{
            color: '#990000',
            fontSize: 16
        },
        tags:{
            wrap:{
                display: 'flex',
                flexWrap: 'wrap',
                paddingTop: 10,
                paddingBottom: 10,
            },
            item:{
                marginRight: 10,
                marginBottom: 30,
                padding: '10px 20px',
                boxShadow: '0 0 3px 3px #efefef',
                borderRadius: 30
            }
        }
    }

    function parseSettingsData(obj){
        const data = [
            {Code: "Title", Title: "Job Title", Value: obj.Title, Display: obj.Title, style: styles.item.lg},
            {Code: "Summary", Title: "Job Summary", Value: obj.Summary, Display: obj.Summary, style: styles.item.sm},
            {Code: "Category", Title: "Category", Value: obj.Category, Display: obj.CategoryName, style: styles.item.sm},
            {Code: "Organization", Title: "Organization", Value: obj.Organization, Display: obj.OganizationName, style: styles.item.sm},
            {Code: "JobType", Title: "Job Type", Value: obj.JobType, Display: obj.JobType, style: styles.item.sm},
            {Code: "WorkMode", Title: "Work Mode", Value: obj.WorkMode, Display: obj.WorkMode, style: styles.item.sm},
            {Code: "Location", Title: "Location", Value: obj.Location, Display: obj.Location, style: styles.item.sm},
            {Code: "Qualification", Title: "Minimum Qualification", Value: obj.Qualification, Display: obj.Qualification, style: styles.item.sm},
            {Code: "ExperienceLevel", Title: "Experience Level", Value: obj.ExperienceLevel, Display: obj.ExperienceLevel, style: styles.item.sm},
            {Code: "ExperienceLength", Title: "Experience Length", Value: obj.ExperienceLength, Display: obj.ExperienceLength, style: styles.item.sm},
            {Code: "Description", Title: "Job Description", Value: obj.Description, Display: obj.Description, style: styles.item.sm},
            {Code: "Salary", Title: "Salary", Value: obj.Salary, Display: obj.Salary, style: styles.item.sm},
        ];
        setSettings(data);
    }

    function settingsItem(obj){
        return (
            <div style={obj.style.wrap}>
                <div className='row'>
                    <div className='col-md-10'>
                        <h4 style={obj.style.title}>{obj.Title}</h4>
                        <div style={obj.style.value}>{settingsItemValue(obj)}</div>
                    </div>
                    <div className='col-md-2'>
                        <Link onClick={()=>editPreset(obj)} style={obj.style.btn}>Edit</Link>
                    </div>
                </div>
            </div>
        )
    }

    function settingsItemValue(obj){
        if(obj.Code == "Tags"){
            return(
                <div style={styles.tags.wrap}>
                    {obj.Value.length > 0 && obj.Value.map(itm=>(
                        <div style={styles.tags.item}>{itm.Name}</div>
                    ))}
                </div>
            )
        }
        else if(obj.Code == "Description"){
            return parse(obj.Display);
        }
        else{
            return obj.Display;
        }
    }

    const titleForm = (
        <div className="form-group">
            <input type="text" value={value} onChange={e => setValue(e.target.value)} className="form-control" placeholder="Enter value" />
        </div>
    )

    const summaryForm = (
        <div className='form-group'>
            <textarea value={value} onChange={e => setValue(e.target.value)} style={styles.input} rows={5} className="form-control" placeholder='Enter Job Summary'></textarea>
        </div>
    )

    const categoryForm = (
        <div className="form-group">
            <select value={value} onChange={e => setValue(e.target.value)} className="form-control">
                <option key={0} value={""}>- Select -</option>
                {categories.map(itm=>(
                    <option key={itm.Id} value={itm.Slug}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const organizationForm = (
        <div className="form-group">
            <OrgSelectControl updateOrg={updateOrg} />
        </div>
    )

    const jobTypeForm = (
        <div className='form-group'>
            <select value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control">
                <option key={-1} value=''>- Select -</option>
                {jobTypesUtil.map((itm, i) => (
                    <option key={i} value={itm.Code}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const workModeForm = (
        <div className='form-group'>
            <select value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control">
                <option key={-1} value=''>- Select -</option>
                {workModeUtil.map((itm, i) => (
                    <option key={i} value={itm.Code}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const locationForm = (
        <div className='form-group'>
            <input type='text' value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control" placeholder='State, Country' />
        </div>
    )

    const qualificationForm = (
        <div className='form-group'>
            <select value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control">
                <option key={-1} value=''>- Select -</option>
                {qualificationUtil.map((itm, i) => (
                    <option key={i} value={itm.Code}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const experienceLevelForm = (
        <div className='form-group'>
            <select value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control">
                <option key={-1} value=''>- Select -</option>
                {experienceLevelUtil.map((itm, i) => (
                    <option key={i} value={itm.Code}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const experienceLengthForm = (
        <div className='form-group'>
            <select value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control">
                <option key={-1} value=''>- Select -</option>
                {experienceLengthUtil.map((itm, i) => (
                    <option key={i} value={itm.Code}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const descriptionForm = (
        <div className='form-group'>
            <Editor 
                containerProps={{ style: { minHeight: 300 } }}
                value={value}
                onChange={handleDescription}
            />
        </div>
    )

    const salaryForm = (
        <div className='form-group'>
            <input type='text' value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control" placeholder='Example: $5000 - $7000' />
        </div>
    )

    const tagsForm = (
        <Tags params={{tagList: tagList, setTagList: setTagList}} />
    )

    return (
        <section style={styles.page}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-2'></div>
                    <div className='col-md-10'>

                        <div style = {styles.heading}>
                            <h4 style={styles.title}>Edit Job Post</h4>
                            <div style={styles.link}>

                            </div>
                        </div>

                        <hr />

                        {settings.map(itm=>(
                            <div key={itm.Code}>{settingsItem(itm)}</div>
                        ))}

                        <Modal show={modal} onHide={closeModal} backdrop="static" keyboard={false}>
                            <Modal.Header>
                                <Modal.Title style={{fontSize:15}}>{modalTitle}</Modal.Title>
                                <button type="button" onClick={closeModal} className="close">&times;</button>
                            </Modal.Header>
                            <Modal.Body>  
                            
                                {selectedItem == "Title" && titleForm}
                                {selectedItem == "Summary" && summaryForm}
                                {selectedItem == "Category" && categoryForm}
                                {selectedItem == "Organization" && organizationForm}
                                {selectedItem == "JobType" && jobTypeForm}
                                {selectedItem == "WorkMode" && workModeForm}
                                {selectedItem == "Location" && locationForm}
                                {selectedItem == "Qualification" && qualificationForm}
                                {selectedItem == "ExperienceLevel" && experienceLevelForm}
                                {selectedItem == "ExperienceLength" && experienceLengthForm}
                                {selectedItem == "Description" && descriptionForm}
                                {selectedItem == "Salary" && salaryForm}
                                {selectedItem == "Tags" && tagsForm}

                                {frmError != "" && 
                                    <div className="form-group" style={styles.frmError}>{frmError}</div>
                                }
                            
                                <hr />

                                <div className="form-group">
                                    <Link onClick={()=>saveForm()} className='btn btn-primary'>{posting? "POSTING ...": "SAVE"}</Link>
                                </div>

                            </Modal.Body> 
                        </Modal>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default JobPostEdit;